module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"free_plan":"Free Trial","description":"Activate your 90 days free trial for your Workspace"},"th":{"free_plan":"ทดลองใช้ฟรี","description":"ทดลองใช้งาน เวิร์คสเปซ เต็มรูปแบบฟรีนาน 90 วัน"}}')
  delete Component.options._Ctor
}
